export default "__VITE_ASSET__C2gJXuC6__"